import { useState } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import Swal from "sweetalert2";
import { createStaffTimeControlService } from "../service/createStaffTimeControl.service";

const initialState = {
  id: null,
  document: null,
  date: "",
};

export const useStaffTimeControlCommand = (refresh) => {
  const fetchData = useFetch();
  const [staffTimeControl, setStaffTimeControl] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({ hasErrors: false, errors: {} });

  const handleChange = ({ name, value }) => {
    setStaffTimeControl((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      hasErrors: false,
      errors: {
        ...prev.errors,
        [name]: null,
      },
    }));
  };

  const createStaffTimeControl = async () => {
    setLoading(true);
    try {
      if (!validations(staffTimeControl)) {
        return;
      }

      const formData = new FormData();
      formData.append("date", staffTimeControl.date);
      formData.append("file", staffTimeControl.document);

      const response = await createStaffTimeControlService(fetchData)(
        formData
      );

      Swal.fire({
        title: "Éxito",
        text: "Control de tiempo del personal creado exitosamente.",
        icon: "success",
      });
      setStaffTimeControl(initialState);
      refresh?.();
      return response;
    } catch (error) {
      console.error("Error creating staff time control:", error);
      setErrors({
        hasErrors: true,
        errors: error.response?.data || {
          general: "An error occurred while creating the staff time control.",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const validations = (data) => {
    const newErrors = {};
    if (!data.date) {
      newErrors.date = "La fecha es requerida.";
    }
    if (!data.document) {
      newErrors.document = "El documento es requerido.";
    }
    if (
      data.document &&
      ![
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "text/csv"
      ].includes(data.document.type)
    ) {
      newErrors.document = "El archivo debe ser un Excel o CSV.";
    }

    const hasErrors = Object.keys(newErrors).length > 0;
    setErrors({
      hasErrors,
      errors: newErrors,
    });
    return !hasErrors;
  };

  return {
    staffTimeControl,
    loading,
    errors,
    handleChange,
    createStaffTimeControl,
  };
};
